import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {Avatar, Box, Button, Typography} from '@mui/material';
import {User} from '@cp/model';

export interface NavBarMobileMenuDrawerUserProps {
  user: User;
  userMenu: AvatarMenuItem[];
  onCloseMenu: () => void;
}

export default function NavBarMobileMenuDrawerUser({user, userMenu, onCloseMenu}: NavBarMobileMenuDrawerUserProps) {
  const handleItemClick = (item: AvatarMenuItem) => {
    // Close the mobile menu first
    onCloseMenu();
    // Then execute the original onClick if it exists
    if (item.onClick) {
      item.onClick();
    }
  };

  // Use userRecord if available, fallback to Firebase user data
  const displayName = user?.name || user?.email?.split('@')[0] || 'User';
  const photoUrl = user?.photoUrl;

  return (
    <Box sx={{borderTop: '1px solid', borderColor: 'divider', pt: 2}}>
      <Box sx={{display: 'flex', alignItems: 'center', mb: 2}}>
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: 'secondary.main',
            color: 'white',
            mr: 2,
          }}
          src={photoUrl || undefined}
        >
          {displayName[0]?.toUpperCase() || 'U'}
        </Avatar>
        <Box>
          <Typography variant="subtitle2" sx={{fontWeight: 600}}>
            {displayName}
          </Typography>
          <Typography variant="caption" sx={{color: 'text.secondary'}}>
            {user?.email}
          </Typography>
        </Box>
      </Box>

      {userMenu.map((item) => (
        <Button
          key={typeof item.label === 'string' ? item.label : item.label?.toString()}
          startIcon={item.icon}
          fullWidth
          onClick={() => handleItemClick(item)}
          sx={{
            justifyContent: 'flex-start',
            color: 'text.primary',
            mb: 1,
            '&:hover': {
              backgroundColor: 'grey.100',
            },
          }}
        >
          {item.label}
        </Button>
      ))}
    </Box>
  );
}
